import Vue from "vue";

declare module "vue/types/vue" {
  // tslint:disable-next-line interface-name
  interface Vue {
    skeletonsMixin_removeSkeleton: () => void;
  }
}

export default Vue.extend({
  methods: {
    skeletonsMixin_removeSkeleton(): void {
      const appLoader = document.querySelector(".app-loader");

      if (appLoader) {
        appLoader.classList.add("load-completed");
      }
    }
  }
});
